<template>
  <v-container fluid>
    <!-- JOB DETAILS -->
    <v-dialog v-model="editDialog" max-width="800">
      <v-card class="pa-1" id="edit-card">
        <v-card-title class="headline mb-4 ml-3"
          >Job Details
          <v-btn
            :to="`/jobs/edit/${currentJob.id}`"
            class="ml-4"
            small
            color="primary"
            v-if="
              user.permissionGroups &&
                user.permissionGroups.includes('manageJobSites')
            "
            ><v-icon small left>edit</v-icon> EDIT</v-btn
          >
          <v-spacer></v-spacer>
          <v-icon @click="editDialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td><strong>Address</strong></td>
                  <td>
                    {{ currentJob.address }}
                  </td>
                </tr>
                <tr v-if="currentJob.geolocation">
                  <td><strong>Coordinates</strong></td>
                  <td>
                    Lat: {{ currentJob.geolocation.latitude }}, Lon:
                    {{ currentJob.geolocation.longitude }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Job ID</strong></td>
                  <td>
                    {{ currentJob.jobId }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Proposal Number</strong></td>
                  <td>
                    {{ currentJob.proposalNumber }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Entity</strong></td>
                  <td>
                    {{ currentJob.entity || "-" }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Estimator</strong></td>
                  <td>
                    {{
                      currentJob.estimator
                        ? currentJob.estimator.name
                        : "None Selected"
                    }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Date Awarded</strong></td>
                  <td>
                    <span v-if="currentJob.dateAwarded"
                      >{{ currentJob.dateAwarded | moment("MMM Do, YYYY") }}
                    </span>
                    <span v-else>-</span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Department</strong></td>
                  <td>
                    {{ currentJob.department.join(", ") }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Project Managers</strong></td>
                  <td>
                    <div v-if="currentJob.projectManagers">
                      {{
                        currentJob.projectManagers
                          .map((pm) => pm.name)
                          .join(", ")
                      }}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td><strong>Contract Value</strong></td>
                  <td>
                    {{ currentJob.contractValue | currency }}
                    <div
                      class="caption grey--text"
                      v-if="currentJob.scopeBreakdownNote"
                    >
                      {{ currentJob.scopeBreakdownNote }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><strong>Total Budget</strong></td>
                  <td>
                    {{ currentJob.totalBudget | currency }}
                    <div
                      class="caption grey--text"
                      v-if="currentJob.totalBudgetNote"
                    >
                      {{ currentJob.totalBudgetNote }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><strong>Estimated Budget - LABOR</strong></td>
                  <td>
                    {{ currentJob.laborBudget | currency }}
                    {{
                      currentJob.manDays
                        ? `(${currentJob.manDays} Man Days)`
                        : ""
                    }}
                    <div
                      class="caption grey--text"
                      v-if="currentJob.laborBudgetNote"
                    >
                      {{ currentJob.laborBudgetNote }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><strong>Estimated Budget - DUMPING</strong></td>
                  <td>
                    {{ currentJob.dumpingBudget | currency }}
                    <div
                      class="caption grey--text"
                      v-if="currentJob.dumpingBudgetNote"
                    >
                      {{ currentJob.dumpingBudgetNote }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><strong>Estimated Budget - MATERIAL</strong></td>
                  <td>
                    {{ currentJob.materialBudget | currency }}
                    <div
                      class="caption grey--text"
                      v-if="currentJob.materialBudgetNote"
                    >
                      {{ currentJob.materialBudgetNote }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><strong>Estimated Budget - CONSUMABLES</strong></td>
                  <td>
                    {{ currentJob.consumablesBudget | currency }}
                    <div
                      class="caption grey--text"
                      v-if="currentJob.consumablesBudgetNote"
                    >
                      {{ currentJob.consumablesBudgetNote }}
                    </div>
                    <div
                      v-if="currentJob.consumablesBudgetAlert"
                      class="caption grey--text"
                    >
                      <v-icon small color="grey">notifications</v-icon> An email
                      will be sent when the consumables cost reaches
                      {{ currentJob.consumablesBudgetAlert | currency }}.
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><strong>Subcontractor Value</strong></td>
                  <td>
                    {{ currentJob.subcontractorValue | currency }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Estimated Timeframe</strong></td>
                  <td>
                    <span v-if="currentJob.estimatedStartDate"
                      >{{
                        currentJob.estimatedStartDate | moment("MMM Do, YYYY")
                      }}
                    </span>
                    <span v-if="currentJob.estimatedCompletionDate">
                      -
                      {{
                        currentJob.estimatedCompletionDate
                          | moment("MMM Do, YYYY")
                      }}
                    </span>
                    <div v-if="currentJob.estimatedDays" class="grey--text">
                      Approximately {{ currentJob.estimatedDays }} days
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><strong>Operations Notes</strong></td>
                  <td>
                    {{ currentJob.operationsNotes }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Status</strong></td>
                  <td>
                    {{ currentJob.status }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- END JOB DETAILS -->

    <v-layout wrap>
      <v-flex xs12 class="headline mb-4">
        Job Sites
        <v-btn
          color="primary"
          small
          class="ml-4"
          to="/jobs/new"
          v-if="user.isAdmin"
        >
          <v-icon small class="mr-2">add</v-icon>New Job Form
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-tabs>
          <v-tab @click="getOpenJobs"
            >Open
            <span class="caption ml-1 grey--text"
              >({{ jobsCount }})</span
            ></v-tab
          >
          <v-tab @click="getOtherJobs('closed')">Closed</v-tab>
          <v-tab @click="getOtherJobs('draft')">Draft</v-tab>
          <v-tab @click="getExternalTrJobs">External</v-tab>
        </v-tabs>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="tableItems"
            :search="search"
            :items-per-page="25"
            :loading="loading"
            loading-text="Loading Tool Orders..."
            sort-by="createDate"
            sort-desc
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-1">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="search"
                  append-icon="search"
                  label="Filter by address"
                ></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.address="{ item }">
              <p
                class="ma-0 pa-0 body-2 font-weight-bold"
                style="line-height:1.4em"
              >
                {{ item.street }}
                <span class="font-weight-regular"> {{ item.street2 }}</span>
              </p>

              <p class=" ma-0 pa-0" style="line-height:1.4em">
                {{ item.city }}
                {{ item.postalCode }}
              </p>
              <div class="caption grey--text ">
                Created: {{ item.createDate.toDate() | moment("MMM Do YYYY") }}
              </div>
            </template>
            <template v-slot:item.department="{ item }">
              <span v-if="item.department">
                {{ item.department.join(", ") }}
              </span>
            </template>
            <template v-slot:item.projectManagers="{ item }">
              <span v-if="item.projectManagers">
                {{ item.projectManagers.map((pm) => pm.name).join(", ") }}
              </span>
            </template>
            <template v-slot:item.status="{ item }">
              <v-btn color="primary" text outlined small @click="editJob(item)"
                ><v-icon small left>description</v-icon> details</v-btn
              >
              <v-btn
                color="primary"
                text
                outlined
                small
                :to="`/jobs/orders/${item.id}`"
                class="ml-2"
                ><v-icon small left>receipt</v-icon> orders</v-btn
              >
              <v-btn
                color="primary"
                text
                outlined
                small
                :to="`/jobs/cost/${item.id}`"
                class="ml-2"
                ><v-icon small left>local_atm</v-icon> Cost</v-btn
              >
              <v-btn
                color="primary"
                text
                outlined
                small
                :to="`/jobs/gallery/${item.id}`"
                class="ml-2"
                ><v-icon small left>photo_library</v-icon> Gallery</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import utils from "@/helpers/utils";
import fb from "@/main";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      currentJob: {},
      currentJobWorkOrders: [],
      search: "",
      activeTab: "open",
      loading: false,
      valid: true,
      statesList: utils.statesList,
      jobSites: [],
      editDialog: false,
      headers: [
        { text: "Job Id", value: "jobId", width: "90" },
        {
          text: "Address",
          align: "left",
          value: "address",
          width: "280",
        },
        { text: "Entity", value: "entity", align: "left", width: "120" },
        { text: "Type", value: "department", align: "left" },
        { text: "PM", value: "projectManagers", align: "left" },
        { text: "", value: "status", align: "right", width: "500" },
      ],
      closedJobs: [],
      externalTrJobs: [],
      draftJobs: [],
      pmList: [],
      numberWithCommas: utils.numberWithCommas,
    };
  },
  async created() {
    this.jobSites = this.openJobs;
    // get project managers for assignments
    const pmList = await fb.db
      .collection("users")
      .where("role", "==", "Project Manager")
      .get();
    this.pmList = [];
    pmList.forEach((u) => {
      this.pmList.push({
        name: u.data().firstName + " " + u.data().lastName,
        email: u.data().email,
        id: u.id,
        notifications: {
          toolOrders: true,
          toolPickups: true,
          consumablesBudget: true,
        },
      });
    });
  },
  computed: {
    ...mapState({
      openJobs: (state) => state.jobSites,
      jobsCount: (state) => state.jobSites.length,
      user: (state) => state.user,
    }),
    tableItems() {
      if (this.activeTab === "open") return this.openJobs;
      if (this.activeTab === "externalTr") return this.externalTrJobs;
      return this.closedJobs;
    },
  },
  methods: {
    getOpenJobs() {
      this.activeTab = "open";
    },
    async getOtherJobs(type) {
      try {
        this.loading = true;
        this.activeTab = type;
        const jobSites = await fb.db
          .collection("jobSites")
          .where("status", "==", type)
          .get();
        this.closedJobs = [];
        jobSites.forEach((u) => {
          this.closedJobs.push({
            id: u.id,
            ...u.data(),
          });
        });
        this.loading = false;
      } catch (error) {
        alert("Error getting jobs.");
        this.loading = false;
        console.log("Error getting orders: ", error);
      }
    },
    async getExternalTrJobs() {
      try {
        this.loading = true;
        this.activeTab = "externalTr";
        const jobSites = await fb.db
          .collection("jobSites")
          .where("department", "array-contains", "External Truck Request")
          .orderBy("createDate", "desc")
          .get();
        this.externalTrJobs = [];
        jobSites.forEach((u) => {
          this.externalTrJobs.push({
            id: u.id,
            ...u.data(),
          });
        });
        this.loading = false;
      } catch (error) {
        alert("Error getting external truck request jobs.");
        this.loading = false;
        console.log("Error getting external TR jobs: ", error);
      }
    },
    async editJob(job) {
      this.currentJob = {};
      this.currentJobWorkOrders = [];
      this.currentJob = { ...job };
      if (
        this.currentJob.estimatedStartDate &&
        this.currentJob.estimatedCompletionDate
      ) {
        this.currentJob.estimatedDays = moment(
          this.currentJob.estimatedCompletionDate,
        ).diff(moment(this.currentJob.estimatedStartDate), "days");
      }
      const workOrderPackages = await fb.db
        .collection("workOrderPackages")
        .where("jobSiteId", "==", this.currentJob.id)
        .get();
      workOrderPackages.forEach((u) => {
        this.currentJobWorkOrders.push({
          id: u.id,
          ...u.data(),
        });
      });
      this.editDialog = true;
    },
  },
};
</script>

<style>
#edit-card input,
#edit-card .theme--light.v-select .v-select__selection--disabled {
  color: black !important;
}
</style>
